import React from 'react';

const faqs = [
  {
    q: 'What is PutPen?',
    a: 'PutPen is a smart Task Manager application designed to assign tasks, track progress, and automate appraisals based on employee performance. It eliminates workplace politics and ensures every contribution is valued.'
  },
  {
    q: 'How do I sign up on PutPen?',
    a: [
      'To sign up:',
      '1. Visit our website.',
      '2. Click on “Sign Up.”',
      '3. Enter your name, company email, and create a password.',
      '4. Verify your account through the confirmation email.',
      '5. Log in to start using PutPen.'
    ]
  },
  {
    q: 'How do I log in?',
    a: 'Once your account is created, you can log in using your registered email and password on either the web or mobile app. You can also enable biometric login (Face ID/Fingerprint) for quick access.'
  },
  {
    q: 'How do I assign or receive a task?',
    a: 'Managers can create tasks and assign them to team members by selecting “Add Task” → Enter task details → Choose assignee(s) → Set deadline → Click “Assign.”'
  },
  {
    q: 'Can I track team performance?',
    a: 'Yes, PutPen automatically generates performance analytics and appraisals based on completed tasks, deadlines met, and task quality scores.'
  },
  {
    q: 'Does PutPen send reminders?',
    a: 'Yes, automated reminders and follow-ups are sent to both managers and employees to ensure task completion on time.'
  },
  {
    q: 'What are the available payment methods?',
    a: [
      'Share your details and submit your requirements to connect with our team.',
      'PutPen supports payments via:',
      '- Credit/Debit Cards (Visa, MasterCard, Amex)',
      '- PayPal',
      '- UPI / Net Banking (for Indian users)',
      '- Apple Pay / Google Pay (mobile app users)'
    ]
  },
  {
    q: 'Can I change or upgrade my plan?',
    a: 'Yes, you can upgrade, downgrade, or cancel your subscription anytime from your account dashboard. Changes will reflect in the next billing cycle.'
  },
  {
    q: 'Is there a free trial available?',
    a: 'Yes, we offer a 7-day free trial with full access to all features. No credit card required to start.'
  },
  {
    q: 'Is my data secure?',
    a: 'Absolutely. PutPen uses end-to-end encryption (AES-256) and complies with GDPR standards to protect user data.'
  },
  {
    q: 'What should I do if I forget my password?',
    a: 'Click “Forgot Password” on the login page, enter your registered email, and follow the instructions in the password reset email.'
  },
  {
    q: 'How can I contact customer support?',
    a: 'You can reach us anytime at support@putpen.com or ai@uniqloop.com through the in-app chat feature for 24/7 assistance.'
  },
  {
    q: 'Who can use PutPen?',
    a: 'PutPen is ideal for individuals, teams, and enterprises looking to improve productivity, transparency, and performance evaluation.'
  },
  {
    q: 'Does PutPen integrate with other tools?',
    a: 'Yes, PutPen integrates with Slack, Microsoft Teams, Google Calendar, and other productivity platforms.'
  },
  {
    q: 'How often is the app updated?',
    a: 'We release regular updates to introduce new features, enhance performance, and ensure security compliance.'
  }
];

const FAQ = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-8 py-10 sm:py-12">
        <h1 className="section-title mb-2 text-3xl sm:text-4xl">Frequently Asked Questions</h1>
        <p className="section-subtitle mb-6">Find quick answers about PutPen, plans, and features.</p>
        <div className="space-y-4">
          {faqs.map((item, idx) => (
            <div key={idx} className="card p-5">
              <div className="text-lg font-semibold text-text">{item.q}</div>
              {Array.isArray(item.a) ? (
                <div className="mt-2 text-secondary-text whitespace-pre-line">{item.a.join('\n')}</div>
              ) : (
                <p className="mt-2 text-secondary-text">{item.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
